import { html } from 'lit';
import { t } from 'src/i18n';
import { customElement, property } from 'lit/decorators.js';
import 'src/content/entity-content';
import '../../library/editors/index.js';
import '../../library/fields/index.js';
import '../../library/fields/d-expansion.js';
import '../../library/lists/d-list-section-attachment.js';
import '../../pages/computers-page/d-edit-single-related-item.js';
import { DataMapElement } from './data-map-element.js';
import type { NetworkFirewallEditItem } from './network-firewall-edit-item';
import type { NetworkFirewall } from './network-firewall';
import type { SelectDropdownOption } from '../../library/editors/elements/select-dropdown-option';

/**
 *
 */
@customElement('d-network-firewall-view')
export class DNetworkFirewallView extends DataMapElement<NetworkFirewall, NetworkFirewallEditItem> {
  @property({ type: String })
  name = '';
  @property({ type: String })
  uuid = '';
  @property({ type: String })
  type = '';
  @property({ type: String })
  connectionType = '';
  @property({ type: String })
  firewall = '';
  @property({ type: String })
  firewallName = '';
  @property({ type: String })
  supplierUuid = '';
  @property({ type: String })
  systemUpdateOperatorType = '';
  @property({ type: String })
  systemUpdateOperator = '';
  @property({ type: String })
  antiVirusOperatorType = '';
  @property({ type: String })
  antiVirusOperator = '';
  @property({ type: String })
  isp = '';
  @property({ type: String })
  containedNewComputerUuid = '';
  @property({ type: Object })
  containedNewComputer: any = {};
  @property({ type: Boolean })
  connectionOpened = false;
  @property({ type: Boolean })
  firewallOpened = false;
  @property({ type: Boolean })
  networkOpened = false;
  @property({ type: Boolean })
  newElement = false;
  @property({ type: Array })
  partners = [];
  @property({ type: Array })
  networks: any[] = [];
  @property({ type: Array })
  computers: any[] = [];
  @property({ type: Object })
  viewOptions: any = {};
  @property({ type: Boolean })
  hideDetails = false;
  @property({ type: Number })
  organizationId = 0;
  @property({ type: Number })
  token = 0;
  @property({ type: Boolean, attribute: 'write-access', reflect: true })
  writeAccess = false;
  @property({ type: Boolean })
  onlyNew = false;
  @property({ type: Boolean })
  editModeForConnection = false;
  @property({ type: Boolean })
  editModeForFirewall = false;
  @property({ type: Boolean })
  editModeForNetwork = false;
  private firewallOptions: SelectDropdownOption[] = [
    { value: 'NONE', text: t('computers.options.none') },
    { value: 'NHN', text: t('computers.options.firewallNhnNhnLine') },
    { value: 'NHNotherISP', text: t('computers.options.firewallNhnOwnLine') },
    { value: 'OTHER', text: t('computers.options.firewallOtherSpecify') },
  ];

  _operatorIsExternal(operatorType) {
    return operatorType === 'external' || operatorType === 'internalAndExternal';
  }

  _getOperatorTypeValue(id) {
    let result = '';
    const list = this.operatorTypes();
    for (const item1 of list) {
      if (id === item1.value) {
        result = item1.text;
      }
    }

    if (result === t('computers.options.operatorChoose')) {
      result = t('computers.options.notSelected');
    }

    return result;
  }

  _getName(type, uuid) {
    if (Array.isArray(uuid)) {
      uuid = uuid[0];
    }
    for (const item1 of type) {
      if (item1.uuid === uuid) {
        return item1.name;
      }
    }
  }

  renderUnitEdit(editItem: NetworkFirewallEditItem) {
    return html`
      <d-section>
        <d-select-dropdown
          theme-page
          field="firewalls_firewall"
          .options="${this.firewallOptions}"
          value="${editItem.firewallType}"
          @value-changed=${(e: CustomEvent<{ value: string }>) => {
            e.stopPropagation();
            this.editItem = {
              ...editItem,
              firewallType: e.detail.value,
            };
          }}
        >
        </d-select-dropdown>
      </d-section>
      <d-expansion ?opened=${editItem.firewallType === 'OTHER'}>
        <d-section style="border-top: none; padding-top: 0">
          <d-edit-text
            theme-page
            value="${editItem.firewallName}"
            @value-changed=${(e: CustomEvent<{ value: string }>) => {
              e.stopPropagation();
              this.editItem = {
                ...editItem,
                firewallName: e.detail.value,
              };
            }}
          >
          </d-edit-text>
        </d-section>
      </d-expansion>
    `;
  }

  _displayTypeName(): string {
    return t('computers.firewall.typeName');
  }

  _displayName() {
    if (this.item.firewallType === 'NHN') {
      return t('computers.options.firewallNhnNhnLine');
    }
    if (this.item.firewallType === 'NHNotherISP') {
      return t('computers.options.firewallNhnOwnLine');
    }
    if (this.item.firewallType === 'OTHER') {
      return this.item.firewallName;
    }
    return t('computers.options.none');
  }

  _isValid() {
    return true;
  }

  initializeEditItem(): NetworkFirewallEditItem {
    return {
      firewallType: this.item.firewallType,
      firewallName: this.item.firewallName,
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-network-firewall-view': DNetworkFirewallView;
  }
}
